<template>

 <section class="banner-section3">
      <div class="container">
        <blockquote class="style-4">
          <p>{{data.title}}</p>
        </blockquote>
      </div>
    </section>
</template>

<script>
export default {
  name: 'Banner2',
  props: {
    data: Object
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
